import myTraderaItemActions from './my-tradera-items';
import { setCookie } from './cookies';
import TEXT_STRINGS from '../../constants/text-strings';
import uiActions from 'tradera-state/ui/actions';
import uiActionTypes from 'tradera-state/ui/action-types';
import { whenInitialized } from 'tradera-lang/boot-languages';
import { selectMyTraderaItemsState } from 'tradera-apps/my-tradera/app/state/reducers/my-tradera-items';
import { routeInformationFactory } from '../../constants/routes';
import fetch from '../../utils/fetch';
import purchaseOrderActions from './purchase-order';

const actionTypes = {
    SEARCHING: 'SEARCHING',
    CHANGE_URL_PARAMS: 'CHANGE_URL_PARAMS',
    ERROR: 'ERROR',
    HIDE_NOTIFICATIONS: 'HIDE_NOTIFICATION',
    OPEN_MODAL: 'OPEN_MODAL',
    SET_BREAKPOINT: 'SET_BREAKPOINT',
    MOBILE_MENU: 'INTERACT_W_MOBILE_MENU',
    MOBILE_ACTIONS: 'INTERACT_W_MOBILE_ACTIONS',
    SET_MEMBER_MESSAGING_PARTICIPATION: 'SET_MEMBER_MESSAGING_PARTICIPATION',
    OPEN_MESSAGING_MODAL: uiActionTypes.OPEN_MESSAGING_MODAL,
    CLOSE_MESSAGING_MODAL: uiActionTypes.CLOSE_MESSAGING_MODAL,
    SET_TRANSLATED_ROUTE_INFORMATION: 'SET_TRANSLATED_ROUTE_INFORMATION',
    OPEN_CHANGE_SHIPPING: 'MYT/OPEN_CHANGE_SHIPPING',
    CLOSE_CHANGE_SHIPPING: 'MYT/CLOSE_CHANGE_SHIPPING',
    OPEN_SET_DICOUNT: 'MYT/OPEN_SET_DICOUNT',
    CLOSE_SET_DICOUNT: 'MYT/CLOSE_SET_DICOUNT',
    SET_COMBINED_SHIPPING_ENABLED: 'MYT/SET_COMBINED_SHIPPING_ENABLED'
};

const openModal = options => ({
    type: actionTypes.OPEN_MODAL,
    payload: options
});

const searching = payload => ({
    type: actionTypes.SEARCHING,
    payload: payload
});

const error = error => ({
    type: actionTypes.ERROR,
    payload: error === true ? TEXT_STRINGS.ERRORS.GENERIC : error
});

const setCombinedShippingEnabled = () => async dispatch => {
    try {
        const data = await fetch(
            '/api/webapi/member/profile/getiscombinedshippingenabled',
            {
                method: 'GET'
            }
        );
        return dispatch({
            type: actionTypes.SET_COMBINED_SHIPPING_ENABLED,
            payload: data.isEnabled
        });
    } catch (error) {
        return myTraderaItemActions.handleError(dispatch, error);
    }
};

const changeListViewType = (page, listViewType) => (dispatch, getState) => {
    const state = getState();
    const myTraderaItemsState = selectMyTraderaItemsState(state);

    dispatch(purchaseOrderActions.resetPurchaseOrder());
    dispatch(myTraderaItemActions.resetMyTraderaItems());

    dispatch(setCookie('LIST_VIEW_TYPE_' + page.listType, listViewType));

    if (myTraderaItemsState.itemsByID) {
        dispatch(myTraderaItemActions.rebuildList());
    }
};

const scrollToInitialScroll = () => {
    const initialScrollEls = document.querySelectorAll('[data-initial-scroll]');
    if (initialScrollEls.length > 0) {
        window.scrollTo(0, initialScrollEls[0].offsetTop || 0);
    }
};

const hideActualNotification = notification => ({
    type: actionTypes.HIDE_NOTIFICATIONS,
    payload: notification
});

const hideNotification = notification => dispatch => {
    const notificationName = `hideNotification-${notification}`;
    const expires = new Date();
    expires.setMonth(expires.getMonth() + 3);
    dispatch(setCookie(notificationName, notificationName, expires));
    dispatch(hideActualNotification(notification));
};

const mobileMenu = forceClose => ({
    type: actionTypes.MOBILE_MENU,
    payload: forceClose
});

const mobileActions = forceClose => ({
    type: actionTypes.MOBILE_ACTIONS,
    payload: forceClose
});

const setBreakPoint = breakpoint => ({
    type: actionTypes.SET_BREAKPOINT,
    payload: breakpoint
});

const setMemberMessagingParticipation = toggle => ({
    type: actionTypes.SET_MEMBER_MESSAGING_PARTICIPATION,
    payload: toggle
});

/*
    Reusing actions and reducers for messaging modal from global
    redux store to reduce duplicate code
*/
const openMessagingModal = payload => uiActions.openMessagingModal(payload);

const closeMessagingModal = payload => uiActions.closeMessagingModal(payload);

export const setTranslatedRouteInformation = dispatch => {
    return whenInitialized().then(({ t, toLocalizedUrl }) => {
        const payload = routeInformationFactory(t, toLocalizedUrl);
        dispatch({
            type: actionTypes.SET_TRANSLATED_ROUTE_INFORMATION,
            payload
        });

        return undefined;
    });
};

const openChangeShipping = payload => ({
    type: actionTypes.OPEN_CHANGE_SHIPPING,
    payload: payload
});

const closeChangeShipping = () => ({
    type: actionTypes.CLOSE_CHANGE_SHIPPING,
    payload: false
});

const openSetDiscount = payload => ({
    type: actionTypes.OPEN_SET_DICOUNT,
    payload: payload
});

const closeSetDiscount = () => ({
    type: actionTypes.CLOSE_SET_DICOUNT,
    payload: false
});

const openShareModal = payload => ({
    type: uiActionTypes.OPEN_SHARE_MODAL,
    payload
});

const closeShareModal = () => ({
    type: uiActionTypes.CLOSE_SHARE_MODAL,
    payload: false
});

export default {
    setCombinedShippingEnabled,
    actionTypes,
    searching,
    hideNotification,
    changeListViewType,
    hideActualNotification,
    scrollToInitialScroll,
    openModal,
    setBreakPoint,
    error,
    mobileMenu,
    mobileActions,
    setMemberMessagingParticipation,
    openMessagingModal,
    closeMessagingModal,
    openChangeShipping,
    closeChangeShipping,
    openSetDiscount,
    closeSetDiscount,
    openShareModal,
    closeShareModal
};
